export const ArrayRequiredTestFunction = (value: unknown) => Array.isArray(value) ? value.length > 0 : false;
export const ObjectRequiredTestFunction = (value: unknown) => (value !== null && typeof value === 'object') ?  Object.keys(value).length > 0 : false;
export const ArrayRequiredMinLenTestFunction = (min: number) => (value: unknown) => Array.isArray(value) ? value.length >= min : false;
export const preventEnterKeySubmission = (e: React.KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>) => {
  const target = e.target as HTMLInputElement | HTMLTextAreaElement;
  const keyCode = e.keyCode ? e.keyCode : e.which;

  //if (keyCode === 13 && target.type !== 'url' && !['TEXTAREA'].includes(target.tagName)) {
  if (keyCode === 13 && !['TEXTAREA'].includes(target.tagName)) {
    e.preventDefault();
  }
};